import { render, staticRenderFns } from "./Legitrans.vue?vue&type=template&id=2092f6fd&scoped=true"
import script from "./Legitrans.vue?vue&type=script&lang=js"
export * from "./Legitrans.vue?vue&type=script&lang=js"
import style0 from "./Legitrans.vue?vue&type=style&index=0&id=2092f6fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092f6fd",
  null
  
)

export default component.exports